<template>
  <section class="full SectionReason">
    <div class="title">
      펀다에이아이 번개입금 <b>우리동네 크라우드펀딩</b>을<br />
      선택하는 이유
    </div>
    <div class="list slow delay-500ms d-flex" ref="list">
      <div class="item-container"><SectionReasonOne /></div>
      <div class="item-container"><SectionReasonTwo /></div>
    </div>
  </section>
</template>

<script>
import SectionReasonOne from './SectionReasonOne'
import SectionReasonTwo from './SectionReasonTwo'
export default {
  name: 'SectionReason',
  components: {
    SectionReasonOne,
    SectionReasonTwo,
  },
  props: {},
  data: function () {
    return {}
  },
  computed: {},
  async created() {},
  destroyed() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.SectionReason {
  width: 100%;
  background-color: #f2f9ff;
  padding-top: 60px;
  padding-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .title {
    font-family: 나눔스퀘어, 'NanumSquare', sans-serif !important;
    width: 100%;
    font-weight: 800;
    font-size: 25px;
    line-height: 1.36;
    letter-spacing: -0.79px;
    text-align: center;
    color: #333333;

    b {
      color: #1baaf1;
    }
  }

  .list {
    flex-wrap: wrap;
    width: 100%;
    margin-top: 30px;
    column-gap: 16px;
    justify-content: center;
    .item-container {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-bottom: 30px;
    }
  }
}
</style>
